import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

document.querySelectorAll('.highlighted_categories')?.forEach((element) => {
    const setUniformHeight = () => {
        const cards = element.querySelectorAll('.LoopProduct');

        if (!cards.length) return;

        let maxHeight = 0;

        cards.forEach((card) => {
            card.style.height = '';
            maxHeight = Math.max(maxHeight, card.offsetHeight);
        });

        cards.forEach((card) => {
            card.style.height = `${maxHeight}px`;
        });
    };

    const paginationEl = element.parentElement.querySelector(
        '.highlighted_categories-pagination-container',
    );
    const nextEl = element.parentElement.parentElement.querySelector(
        '.highlighted_categories-navigation-right',
    );
    const prevEl = element.parentElement.parentElement.querySelector(
        '.highlighted_categories-navigation-left',
    );

    const swiperInstance = new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            1024: {
                spaceBetween: 32,
            },
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: (index, className) => {
                return `<span class="${className}"></span>`;
            },
        },
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl,
            prevEl,
        },
        on: {
            init: setUniformHeight,
            imagesReady: setUniformHeight,
        },
    });

    setUniformHeight();

    window.addEventListener('resize', setUniformHeight);

    return swiperInstance;
});
